import { render, staticRenderFns } from "./VariableTableList.vue?vue&type=template&id=850ca0ac&"
import script from "./VariableTableList.vue?vue&type=script&lang=ts&"
export * from "./VariableTableList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports